var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.src),expression:"src"}],ref:"lazy",class:_vm.className,style:(`${_vm.styles};background-color: ${_vm.color}`),attrs:{"id":_vm.id ? _vm.id : undefined},on:{"click":_vm.click,"load":_vm.onLoadImg,"error":_vm.onLoadError}})
}
var staticRenderFns = []

export { render, staticRenderFns }